export default __webpack_public_path__ + "locales/de/RoomLogoCover.json?hash=0758a2e5995d86d1c73aa2b9a2de80e0";